import { render, staticRenderFns } from "./contactUsPC.vue?vue&type=template&id=4ff56c81&scoped=true"
import script from "./contactUsPC.vue?vue&type=script&lang=js"
export * from "./contactUsPC.vue?vue&type=script&lang=js"
import style0 from "./contactUsPC.vue?vue&type=style&index=0&id=4ff56c81&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff56c81",
  null
  
)

export default component.exports